module.exports = __webpack_public_path__ + "static/media/moe.d008f30a.pdf";